var map = {
	"./apple-touch-icon-1.png": 73854,
	"./apple-touch-icon-2.png": 91098,
	"./apple-touch-icon-3.png": 9080,
	"./apple-touch-icon-4.png": 31058,
	"./apple-touch-icon-5.png": 42398,
	"./apple-touch-icon-6.png": 32852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5640;